/**
 * Helium Customer Fields — register page (JKL)
 *
 * Uses the official Form API: form.cfForm.setFieldValue(columnKey, value)
 * after forms are mounted. Listeners must not run before cfForm exists.
 *
 * @see https://developers.customerfields.com/front-end-api/js-events/ (cf:ready)
 * @see https://developers.customerfields.com/front-end-api/form-api (setFieldValue, beforeSave)
 */
(function () {
  var root = document.querySelector('.jkl-section-customer-register');
  if (!root) return;

  var cfg = document.getElementById('jkl-register-helium-config');
  var operatingUnit = (cfg && cfg.getAttribute('data-operating-unit')) || '';

  function findForm() {
    return root.querySelector('form#create_customer, form[data-cf-form]') || document.querySelector('form#create_customer, form[data-cf-form]');
  }

  var DEFAULT_COUNTRY_COLUMN_KEYS = ['default_address.country', 'default_address.country_1'];

  function readDefaultCountryValue(form) {
    function valueFromKey(columnKey) {
      var el = form.querySelector('[data-cf-column-key="' + columnKey + '"]');
      if (!el || el.disabled) return null;
      var v = String(el.value || '').trim();
      return v === '' ? null : v;
    }

    var primary = valueFromKey('default_address.country');
    if (primary != null) return primary;
    var secondary = valueFromKey('default_address.country_1');
    if (secondary != null) return secondary;
    return '';
  }

  function applySetFieldValues(form, cfForm) {
    if (!cfForm || typeof cfForm.setFieldValue !== 'function') return;

    var country = readDefaultCountryValue(form);
    if (country) {
      cfForm.setFieldValue('country', window.JKL_COUNTRY_EN_TO_ISO[country] || country);
    }

    if (operatingUnit) {
      // checkbox_list: API accepts the selected value(s); single market = one code
      cfForm.setFieldValue('operating_units_1', operatingUnit);
    }
  }

  function bindHeliumFormApi(form) {
    if (form.dataset.jklCfRegisterApiBound === '1') return;
    if (!form.cfForm || typeof form.cfForm.setFieldValue !== 'function') return;

    form.dataset.jklCfRegisterApiBound = '1';

    var cfForm = form.cfForm;

    applySetFieldValues(form, cfForm);

    // Re-sync country when the address country field changes (user or rules)
    form.addEventListener('cf:field_changed', function (event) {
      var d = event.detail;
      if (!d) return;
      if (DEFAULT_COUNTRY_COLUMN_KEYS.indexOf(d.columnKey) === -1) return;
      var v = d.value;
      if (v != null && String(v).trim() !== '') {
        cfForm.setFieldValue('country', window.JKL_COUNTRY_EN_TO_ISO[v] || v);
      } else {
        applySetFieldValues(form, cfForm);
      }
    });

    // Native select change (in case it does not emit cf:field_changed in all cases)
    DEFAULT_COUNTRY_COLUMN_KEYS.forEach(function (columnKey) {
      var countryEl = form.querySelector('[data-cf-column-key="' + columnKey + '"]');
      if (countryEl) {
        countryEl.addEventListener('change', function () {
          applySetFieldValues(form, cfForm);
        });
      }
    });

    // After client validation, immediately before Helium persists — last chance to set API state
    if (typeof cfForm.beforeSave === 'function') {
      cfForm.beforeSave(function () {
        applySetFieldValues(form, cfForm);
      });
    }
  }

  function onCfReady() {
    var form = findForm();
    if (!form) return;
    bindHeliumFormApi(form);
  }

  document.addEventListener('cf:ready', onCfReady);

  if (typeof window.CF !== 'undefined' && typeof window.CF.ready === 'function') {
    window.CF.ready(onCfReady);
  }
})();
